import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import storage from "../../../../firebaseConfig.js"
import {ref,uploadBytesResumable, getDownloadURL} from "firebase/storage"
import LinearProgress from '@material-ui/core/LinearProgress';
import { NetworkContext } from '../../../../context/NetworkContext';

import { makeStyles } from '@material-ui/styles';
import {
  Button,
 Avatar,
  TextField,
  Paper,
  Typography,
  Switch,
  Grid
} from '@material-ui/core';
import Box from '@material-ui/core/Box';

import Autocomplete from '@material-ui/lab/Autocomplete';
import {

  KeyboardDatePicker,
} from '@material-ui/pickers';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  papercontent: {
      marginTop : theme.spacing(2),
      textAlign : 'center'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  input: {
    display: 'none',
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(2, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {
   
    padding: theme.spacing(1, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  radioGroup: {},
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  }
}));
function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};
const CommodityDetails = props => {
  const { open, onClose, masters, onSave,usercontent, viewtype, className, ...rest } = props;

  const classes = useStyles();

  const initialValues = {
    name: '',
    nameTamil : '',
    nameTelugu : '',
    imageurl : '',
    commodity : {},
    parentcommodity: {},
    status : true
  };
  const [masterlanguages, setMasterLanguages] = React.useState([]);

  const [basicInfo, setBasicInfo] = React.useState({});
  const [percent, setPercent] = React.useState(0);
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [error, setError] = React.useState({error: false,
    message: {
      
    }});
  const [expandProject, setExpandProject] = useState(true);
  const [expandCustomer, setExpandCustomer] = useState(false);
  const [values, setValues] = useState({ ...initialValues });
  const [parentcommodity, setParentcommodity] = useState([]);

  const setData = async (value, name, fun, state) => {
    let url = null;
    let extra = {};
    if (name === "image") {
      if (!value) {
        alert("Please choose a file first!")
        }

        const storageRef = ref(storage, `/commodity/${value.name}`)
        const uploadTask = uploadBytesResumable(storageRef, value);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
          const percent = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          
          // update progress
          setPercent(percent);
          },
          (err) => console.log(err),
          () => {
          // download url
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            console.log("imageurl"+url)
            setValues(values => ({
              ...values,
              ['imageurl']: url
            }));
          });
          }
          );
     
    }

    fun({
      ...state, [name]: value, ...extra
    })
  }


  const handleClear = () => {
    setValues({ ...initialValues });
  };
  React.useEffect(() => {
    if(usercontent && usercontent.id)
    {
      setValues({
        ...usercontent,
        parentcommodity : usercontent.mastercommodity
      })
    }
 }, [usercontent]);

 React.useEffect(() => {
  if(masters.languages)
  {
    let langs_arr = [...masters.languages]
    langs_arr.splice(0,1)
    setMasterLanguages([
      ...langs_arr
    ])
  }
 },[masters]);
 React.useEffect(() => {
  fetchcommodity()
 },[]);
 async function fetchcommodity()
 {
   let commoditylist = await sendNetworkRequest('/admin/getparentcommodity', {}, {},false)

   setParentcommodity(commoditylist.module)
   
 }
  const handleFieldChange = (event, field, value) => {
    event.persist && event.persist();
    setValues(values => ({
      ...values,
      [field]: value
    }));
  };

  const handleTagAdd = () => {
    setValues(values => {
      const newValues = { ...values };

      if (newValues.tag && !newValues.tags.includes(newValues.tag)) {
        newValues.tags = [...newValues.tags];
        newValues.tags.push(newValues.tag);
      }

      newValues.tag = '';

      return newValues;
    });
  };
  const handleinputchange = type => e => {
    setValues({
      ...values,
      [type]: e.target.value
    });
  }
  const handleTagDelete = tag => {
    setValues(values => {
      const newValues = { ...values };

      newValues.tags = newValues.tags.filter(t => t !== tag);

      return newValues;
    });
  };
  const handleChange = event => {
    event.persist();

    setValues({
      ...values,
      [event.target.name]:
        event.target.type === 'checkbox'
          ? event.target.checked
          : event.target.value
    });
  };
  const handleoptionchange = type => (event, value) => {
    
    if(type === 'language' && value.length > 0 && value[0].name === 'All')
    {
      
      let langs = [];

      masters.languages.map((element)=> {
        if(element.name != 'All')
        {
          langs.push(element)

        }
      })
      
        masters['languages'] = [
          {
            id : 0,
            name : "All"
          }
        ]
      

      setValues(values => ({
        ...values,
        [type]: langs
      }));
    }else
    {
      if(type === 'language')
      {
        if(value.length > 0)
        {
          masters['languages'] = [
            ...masterlanguages
          ]
        }else{
          masters['languages'] = [
            {
              id : 0,
              name : "All"
            },
            ...masterlanguages
          ]
        }
      }
    
    setValues(values => ({
      ...values,
      [type]: value
    }));
  }
  }
  const handleToggleProject = () => {
    setExpandProject(expandProject => !expandProject);
  };

  const handleToggleCustomer = () => {
    setExpandCustomer(expandCustomer => !expandCustomer);
  };

  const handleSubmit = event => {
    event.preventDefault();
    
      const {language,parentcommodity,imageurl} = values;
      let iserror = false
      let messagecontent = {}
      if(!language || language.length == 0)
      {
        iserror = true
        messagecontent['language'] = "Please select language"
      }else{
        language.map((item,index) => {
          let val = values['name-'+item.name];
          if(!val)
          {
            iserror = true
            messagecontent['name-'+item.name] = `Please enter ${item.name} name`
          }
          
        })
      }

      if(!imageurl)
      {
        iserror = true
        messagecontent['imageurl'] = "Please select image"
      }
      
      if(iserror)
    {
      
    let errorcontent = {
      error : true,
      message : messagecontent
    }

    setError(errorcontent)
  }else{
    let errorcontent = {
      error : false,
      message : messagecontent
    }
    setError(errorcontent)
   onSave && onSave(values);
  }
    
  };

  const paymentStatusOptions = ['Pending', 'Canceled', 'Completed', 'Rejected'];
  const customerAgeOption = ['18 - 30', '30 - 45', '50 - 60', '60+'];

  return (
  <Paper className={classes.papercontent}>  
      <form
        {...rest}
        className={clsx(classes.root, className)}
        onSubmit={handleSubmit}
      >
        
        <div className={classes.content}>
        <Grid container row xs={12} spacing={2}>
          <Grid container item xs={9} spacing={2}>
          <Grid item xs={12}>
            {masters.languages && (values.language || viewtype == 1)  && <Autocomplete
                  multiple
                  id="combo-box-demo"
                  options={masters.languages}
                  margin="dense"
                  fullWidth
                  value={values.language}
                  onChange={handleoptionchange('language')}
                  defaultValue={values.language}
                  filterSelectedOptions
                  getOptionSelected={(option, value) => option.name === value.name}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => <TextField {...params} label={"Languages"} fullWidth margin="dense"
                  error={error?.message?.language}
                  helperText={error?.message?.language}
                  variant="outlined" />}
                /> }
            </Grid>
            <Grid item xs={12}>
            {parentcommodity    && <Autocomplete
                  id="combo-box-demo"
                  options={parentcommodity}
                  margin="dense"
                  fullWidth
                  value={values.parentcommodity}
                  onChange={handleoptionchange('parentcommodity')}
                  defaultValue={values.parentcommodity}
                  filterSelectedOptions
                  getOptionSelected={(option, value) => option.name === value.name}
                  getOptionLabel={(option) => option.name}

                  renderInput={(params) => <TextField {...params} label={"Parent Cmmodity"} 
                 
                  fullWidth margin="dense" variant="outlined" />}
                /> }
            </Grid>
            {values.language != null && values.language.map((order,index)  => (
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            value={values['name-'+order.name]}
                            onChange={handleinputchange('name-'+order.name)}
                           label={"Commodity Name ("+order.name+ "*)"}
                           error={error?.message['name-'+order.name]}
                           helperText={error?.message['name-'+order.name]}
                          />
            </Grid>))}
           
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="Image Url"
                           error={error?.message['imageurl']}
                           helperText={error?.message['imageurl']}
                           value={values.imageurl}
                           onChange={handleinputchange('imageurl')}
                           
                          />
            </Grid>
    
            <Grid
              item
              md={6}
              xs={12}
              container
              row
            >
              <Typography variant="h6" marginTop={32}>Is commodity active?      </Typography>
              <Box width={16}></Box>
              {values.status == true ?  <Switch
                checked={true}
                color="secondary"
                edge="start"
                name="status"
                onChange={handleChange}
              /> : <Switch
              checked={false}
              color="secondary"
              edge="start"
              name="status"
              onChange={handleChange}
            />}
            </Grid>
          </Grid>
          <Grid container xs={3}>
          <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  spacing={2}
                  style={{ display: "grid" }}
                >
                  <Grid style={{ margin: "auto" }}>
                    <input accept="image/*" className={classes.input} id="icon-button-file" type="file"
                      onChange={e => setData(e.target.files[0], "image", setBasicInfo, basicInfo)}
                    />
                    {values.imageurl ? <label htmlFor="icon-button-file">
                      <Avatar src={values.imageurl} style={{ width: 140, height: 140, borderRadius: 10, cursor: "pointer" }} />
                    </label> : <label htmlFor="icon-button-file">
                      <Avatar src={values.imageurl} style={{ width: 140, height: 140, borderRadius: 10, cursor: "pointer" }} />
                    </label>}
                    {percent == 0 || percent == 100 && <LinearProgressWithLabel value={percent} />}

                  </Grid>
                

                </Grid>
                </Grid>
         </Grid>
        </div>
        <div className={classes.actions}>
          {/* <Button
            onClick={handleClear}
            variant="contained"
           
          >
            Clear
          </Button> */}
          <Button
            color="primary"
            type="submit"
            variant="contained"
          >
            Update
          </Button>
        </div>
      </form>
      </Paper> 
  );
};

CommodityDetails.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  open: PropTypes.bool.isRequired,
  masters: PropTypes.object
};

export default CommodityDetails;
